export default "__VITE_ASSET__CMTOcGlu__"